import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Formik, Form } from 'formik';
import React, { useState } from 'react';
import PasswordTextField from '../FormsUI/PasswordTextfield';
import { newPasswordUpdate } from '../../API/APICalls';
import SnackbarShow from '../SnackbarShow';
import { userPasswordChangeFormValidation } from '../../Utils/UserValidations';


const PasswordChange = ({ id }) => {
    const [open, setOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState({
        open: false,
        message: '',
        severity: '',
    });
    const handleResetForm = async (values) => {
        setOpen(false);
        try {
            const response = await newPasswordUpdate(id, values.password);
            if (response.status !== 200) {
                setSnackbarMessage({
                    open: true,
                    message: `New password update failed: ${response.status} Message: ${response.data}`,
                    severity: 'error',
                });
            };
            setSnackbarMessage({
                open: true,
                message: 'New password updated successfully',
                severity: 'success',
            });
        } catch (error) {
            setSnackbarMessage({
                open: true,
                message: `New password update failed: ${error}`,
                severity: 'error',
            });
        };
    };
    const snackbarMessageComp = (snackbarMessage.open)
        ? (<SnackbarShow data={snackbarMessage} setSnackbarMessage={setSnackbarMessage} />)
        : null;

    return (
        <>
            {snackbarMessageComp}
            <Button variant='contained' color='primary' onClick={() => { setOpen(true); }} sx={{ width: '35%', margin: '0 auto', marginTop: '1rem' }}>
                Change Password
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
                <DialogTitle>Set new password</DialogTitle>
                <DialogContent>
                    <Formik initialValues={{ password: '', confirmPassword: '' }}
                        validationSchema={userPasswordChangeFormValidation}
                        onSubmit={handleResetForm}
                    >
                        <Form style={{ display: 'flex', flexDirection: 'column', gap: 15, width: '95%', padding: '5px' }}>
                            <PasswordTextField name='password'
                                label='Password'
                                type='password'
                            />
                            <PasswordTextField name='confirmPassword'
                                label='Confirm Password'
                                type='password'
                            />
                            <DialogActions>
                                <Button onClick={() => { setOpen(false) }} color='secondary'>Cancel</Button>
                                <Button type='submit' color='primary'>Set password</Button>
                            </DialogActions>
                        </Form>
                    </Formik>
                </DialogContent>
            </Dialog>
        </>
    )
};

export default PasswordChange;